export const PARTNER_TOKEN_LENGTH = 128;
